import { useCallback, useEffect, useState } from 'react';
import useFetch from 'use-http';

const useBotDetails = ({ botId }) => {
    const { post } = useFetch();
    const [botDetailResponse, setBotDetailResponse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [statusCode, setStatusCode] = useState(null);

    const getBotDetails = useCallback((request) => {
        setLoading(true);
        const url = `/bot_by_id_anonymous`;

        try {
            post(url, request).then((res) => {
                console.log({ botDetailResponse: res });
                if (res) {
                    setStatusCode(200);
                    setBotDetailResponse(res);
                    setLoading(false);
                }
            });
        } catch (err) {
            console.error(err);
            setStatusCode(500);
            throw err;
        }
    }, [post]);

    useEffect(() => getBotDetails({ botId }), [botId, getBotDetails]);

    return { botDetailResponse, loading, statusCode };
};

export default useBotDetails;
